import { ServiceToolClient } from "api/api";
import { AsyncOperationBuilderWithoutState } from "utilities/api-helper";
import { serviceToolClient } from "../api-clients";

export async function getAvailableServiceTools() {
	return AsyncOperationBuilderWithoutState(
		apiClient => (apiClient as ServiceToolClient).getAvailableServiceTools(),
		serviceToolClient
	);
}